export function isNotEmptyObject(value) {
  return Object.keys(value)?.length === 0
}
